import { render, staticRenderFns } from "./SupportPsySocial.vue?vue&type=template&id=45302f9a&scoped=true&"
import script from "./SupportPsySocial.vue?vue&type=script&lang=js&"
export * from "./SupportPsySocial.vue?vue&type=script&lang=js&"
import style0 from "./SupportPsySocial.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SupportPsySocial.vue?vue&type=style&index=1&id=45302f9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45302f9a",
  null
  
)

export default component.exports